import './App.scss';
import MaintenanceIcon from './assets/maintenance.svg'

function App() {
  return (
    <div className="App">
      <div>
        <img src={MaintenanceIcon} alt="" />
        <h1>Cloud service of AVA has been discontinued</h1>
        <h4>For other solutions contact us at <a href="mailto:sales.ava@andritz.com?subject=Cloud AVA discontinued"><div className="email">sales.ava@andritz.com</div></a></h4>
      </div>
    </div>
  );
}

export default App;
